import {
    DesktopOutlined,
    UserOutlined,
    ShoppingOutlined,
    CarOutlined,
    KeyOutlined,
    PhoneOutlined,
    ToolOutlined,
    CalendarOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import type { MenuProps } from "antd";
import { Link } from "react-router-dom";
import React, { Children, useState } from "react";
import styles from "./LayoutMenu.module.css";

import * as Common from "../commons/common";
import * as String from "../commons/string";
import { get } from "http";
import { useAuthState } from "../provider/AuthProvider";

type MenuItem = Required<MenuProps>["items"][number];

function LayoutMenu() {
    const userDetails = useAuthState();

    const rootSubmenuKeys = ["vehicle", "bbs", "system-setting"];
    const [openKeys, setOpenKeys] = useState([String.titleCampingfairEvent]);

    const onOpenChange: MenuProps["onOpenChange"] = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    function getItem(label: React.ReactNode, key: React.Key, icon?: React.ReactNode, children?: MenuItem[], type?: "group"): MenuItem {
        return {
            key,
            icon,
            children,
            label,
            type,
        } as MenuItem;
    }

    const getMenuItems = () => {
        if (userDetails === undefined || userDetails?.user?.authority === undefined) {
            return adminMenus;
        }

        let menus;

        // console.log("user", userDetails?.user);

        switch (userDetails?.user?.authority) {
            case Common.MEMBER_ROLE.ROLE_ADMIN:
                menus = adminMenus;
                break;
            case Common.MEMBER_ROLE.ROLE_MANAGER:
                menus = managerMenus;
                break;
            case Common.MEMBER_ROLE.ROLE_RENT_MANAGER:
                menus = rentManagerMenus;
                break;
            case Common.MEMBER_ROLE.ROLE_B2B_MANAGER:
                menus = b2bManagerMenus;
                break;
            case Common.MEMBER_ROLE.ROLE_USER:
                menus = userMenus;
                break;
        }

        return menus;
    };

    // const getLoginUserRole = () => {
    //     if (userDetails === undefined || userDetails?.user?.authority === undefined) {
    //         return null;
    //     }

    //     return userDetails?.user?.authority;
    // };

    const adminMenus: MenuItem[] = [
        getItem(<Link to={Common.PAGE_DASHBOARD}>{String.titleDashboard}</Link>, String.titleDashboard, <DesktopOutlined />),
        getItem(<Link to={Common.PAGE_LIST_USERS}>{String.titleUsers}</Link>, String.titleUsers, <UserOutlined />),
        getItem(String.titleSell, String.titleSell, <ShoppingOutlined />, [
            getItem(<Link to={Common.PAGE_LIST_SELLED_CAR}>{String.titleCar}</Link>, String.titleSelledCar),
            getItem(<Link to={Common.PAGE_LIST_ORDERS}>{String.titleOrder}</Link>, String.titleOrder),
            getItem(<Link to={Common.PAGE_LIST_CUSTOMER}>{String.titleCustomer}</Link>, String.titleCustomer),
            getItem(<Link to={Common.PAGE_LIST_REFERENCEROOM}>{String.titleReferenceRoom}</Link>, String.titleReferenceRoom),
            getItem(<Link to={Common.PAGE_LIST_SEELED_CAR_MEDIAS}>{String.titleMedias}</Link>, String.titleSellMedias),
            getItem(<Link to={Common.PAGE_LIST_NOTICE}>{String.titleNotice}</Link>, String.titleNotice),
        ]),
        getItem(String.titleRent, String.titleRent, <CarOutlined />, [
            getItem(<Link to={Common.PAGE_LIST_RENT_CAR}>{String.titleCar}</Link>, String.titleRentCar),
            getItem(<Link to={Common.PAGE_LIST_RESERVATION}>{String.titleReservation}</Link>, String.titleReservation),
            // getItem(<Link to={Common.PAGE_LIST_INFORMATION}>{String.titleInformation}</Link>, String.titleInformation),
            getItem(<Link to={Common.PAGE_LIST_QUESTIONS}>{String.titleQuestions}</Link>, String.titleQuestions),
            getItem(<Link to={Common.PAGE_LIST_MANUALS}>{String.titleManuals}</Link>, String.titleManuals),
            // getItem(<Link to={Common.PAGE_LIST_RENT_CAR_MEDIAS}>{String.titleMedias}</Link>, String.titleRentMedias),
            getItem(<Link to={Common.PAGE_LIST_RENT_REVIEW}>{String.titleRentReview}</Link>, String.titleRentReview),
            getItem(<Link to={Common.PAGE_LIST_RENT_NOTICE}>{String.titleNotice}</Link>, String.titleRentNotice),
            getItem(<Link to={Common.PAGE_LIST_RENT_STATISTICS}>{String.titleRentStatistics}</Link>, String.titleRentStatistics),
            getItem(<Link to={Common.PAGE_LIST_RENT_B2B}>{String.titleRentB2b}</Link>, String.titleRentB2b),
            getItem(<Link to={Common.PAGE_LIST_COUPON}>{String.titleCoupon}</Link>, String.titleCoupon),
            getItem(<Link to={Common.PAGE_LIST_RENT_PEAK_SEASON}>{String.titleRentPeakSeason}</Link>, String.titleRentPeakSeason),
        ]),
        getItem(<Link to={Common.PAGE_LIST_DIGITAL_KEY}>{String.titleDigitalKey}</Link>, String.titleDigitalKey, <KeyOutlined />),
        getItem(<Link to={Common.PAGE_LIST_CARS}>{String.titleRegisterCar}</Link>, String.titleRegisterCar, <CarOutlined />),
        getItem(String.titleEvent, String.titleEvent, <DesktopOutlined />, [
            getItem(<Link to={Common.PAGE_LIST_EVENT_CAMPINGFAIR}>{String.titleCampingfair2023}</Link>, String.titleCampingfair2023),
            getItem(<Link to={Common.PAGE_LIST_EVENT_CAMPINGCARSHOW}>{String.titleCampingCarShow}</Link>, String.titleCampingCarShow),
            getItem(<Link to={Common.PAGE_LIST_EVENT_AUTOSALON}>{String.titleAutoSalon2023}</Link>, String.titleAutoSalon2023),
            getItem(<Link to={Common.PAGE_LIST_EVENT_CAMPNICFAIR}>{String.titleCampnicFair2024}</Link>, String.titleCampnicFair2024),
            getItem(<Link to={Common.PAGE_LIST_EVENT_GREENCAMP}>{String.titleGreenCamp2024}</Link>, String.titleGreenCamp2024),
            getItem(<Link to={Common.PAGE_LIST_EVENT_CAMPINGFAIR_2024}>{String.titleCampingfair2024}</Link>, String.titleCampingfair2024),
            getItem(<Link to={Common.PAGE_LIST_EVENT_CAMPINGFAIR_2025}>{String.titleCampingfair2025}</Link>, String.titleCampingfair2025),
            // getItem(<Link to={Common.PAGE_LIST_SURVEYS}>{String.titleSurveys}</Link>, String.titleSurveys),
        ]),
        getItem(String.titleCustomerServiceCenter, String.titleCustomerServiceCenter, <PhoneOutlined />, [
            // getItem(<Link to={Common.PAGE_LIST_COUNSELING}>{String.titleCounseling}</Link>, String.titleCounseling),
            getItem(<Link to={Common.PAGE_LIST_NOTICES}>{String.titleTextNotice}</Link>, String.titleTextNotice),
            // getItem(<Link to={Common.PAGE_LIST_RELEASE}>{String.titleTextRelease}</Link>, String.titleTextRelease),
        ]),
        // getItem(<Link to={Common.PAGE_LIST_SETUP}>{String.titleSetup}</Link>, String.titleSetup, <ToolOutlined />),
    ];

    const managerMenus: MenuItem[] = [
        getItem(<Link to={Common.PAGE_DASHBOARD}>{String.titleDashboard}</Link>, String.titleDashboard, <DesktopOutlined />),
        getItem(String.titleSell, String.titleSell, <ShoppingOutlined />, [
            getItem(<Link to={Common.PAGE_LIST_SELLED_CAR}>{String.titleCar}</Link>, String.titleSelledCar),
            getItem(<Link to={Common.PAGE_LIST_ORDERS}>{String.titleOrder}</Link>, String.titleOrder),
            getItem(<Link to={Common.PAGE_LIST_CUSTOMER}>{String.titleCustomer}</Link>, String.titleCustomer),
            getItem(<Link to={Common.PAGE_LIST_REFERENCEROOM}>{String.titleReferenceRoom}</Link>, String.titleReferenceRoom),
            getItem(<Link to={Common.PAGE_LIST_SEELED_CAR_MEDIAS}>{String.titleMedias}</Link>, String.titleSellMedias),
            getItem(<Link to={Common.PAGE_LIST_NOTICE}>{String.titleNotice}</Link>, String.titleNotice),
        ]),
        getItem(String.titleEvent, String.titleEvent, <DesktopOutlined />, [
            getItem(<Link to={Common.PAGE_LIST_EVENT_CAMPINGFAIR}>{String.titleCampingfair2023}</Link>, String.titleCampingfair2023),
            getItem(<Link to={Common.PAGE_LIST_EVENT_CAMPINGCARSHOW}>{String.titleCampingCarShow}</Link>, String.titleCampingCarShow),
            getItem(<Link to={Common.PAGE_LIST_EVENT_AUTOSALON}>{String.titleAutoSalon2023}</Link>, String.titleAutoSalon2023),
            getItem(<Link to={Common.PAGE_LIST_EVENT_CAMPNICFAIR}>{String.titleCampnicFair2024}</Link>, String.titleCampnicFair2024),
            getItem(<Link to={Common.PAGE_LIST_EVENT_GREENCAMP}>{String.titleGreenCamp2024}</Link>, String.titleGreenCamp2024),
            getItem(<Link to={Common.PAGE_LIST_EVENT_CAMPINGFAIR_2024}>{String.titleCampingfair2024}</Link>, String.titleCampingfair2024),
            getItem(<Link to={Common.PAGE_LIST_EVENT_CAMPINGFAIR_2025}>{String.titleCampingfair2025}</Link>, String.titleCampingfair2025),
            // getItem(<Link to={Common.PAGE_LIST_SURVEYS}>{String.titleSurveys}</Link>, String.titleSurveys),
        ]),
        getItem(String.titleCustomerServiceCenter, String.titleCustomerServiceCenter, <PhoneOutlined />, [
            // getItem(<Link to={Common.PAGE_LIST_COUNSELING}>{String.titleCounseling}</Link>, String.titleCounseling),
            getItem(<Link to={Common.PAGE_LIST_NOTICES}>{String.titleTextNotice}</Link>, String.titleTextNotice),
            // getItem(<Link to={Common.PAGE_LIST_RELEASE}>{String.titleTextRelease}</Link>, String.titleTextRelease),
        ]),
    ];

    const rentManagerMenus: MenuItem[] = [
        getItem(<Link to={Common.PAGE_DASHBOARD}>{String.titleDashboard}</Link>, String.titleDashboard, <DesktopOutlined />),
        getItem(String.titleRent, String.titleRent, <CarOutlined />, [
            getItem(<Link to={Common.PAGE_LIST_RENT_CAR}>{String.titleCar}</Link>, String.titleRentCar),
            getItem(<Link to={Common.PAGE_LIST_RESERVATION}>{String.titleReservation}</Link>, String.titleReservation),
        ]),
    ];

    const b2bManagerMenus: MenuItem[] = [
        getItem(<Link to={Common.PAGE_LIST_RESERVATION}>{String.titleReservation}</Link>, String.titleReservation, <CalendarOutlined />),
    ];

    const userMenus: MenuItem[] = [
        getItem(<Link to={Common.PAGE_DASHBOARD}>{String.titleDashboard}</Link>, String.titleDashboard, <DesktopOutlined />),
    ];

    return (
        <div>
            <div className={styles.logo} />
            <Menu
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                defaultSelectedKeys={[String.titleOrders]}
                mode="inline"
                theme="dark"
                items={getMenuItems()}
            />
        </div>
    );
}

export default LayoutMenu;
